import { render } from "./SearchResultsList.vue?vue&type=template&id=713007b8"
import script from "./SearchResultsList.vue?vue&type=script&lang=js"
export * from "./SearchResultsList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/SearchResults/SearchResultsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "713007b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('713007b8', __exports__)) {
    api.reload('713007b8', __exports__)
  }
  
  module.hot.accept("./SearchResultsList.vue?vue&type=template&id=713007b8", () => {
    api.rerender('713007b8', render)
  })

}


export default __exports__